export default __webpack_public_path__ + "static/media/health.db116143.png";